import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router";
import { Container } from "@mui/material";

import "./result.scss";
import ResultBody from "../../component/result/resultBody";
import { getSurveyList, updateUserData } from "../../redux/action/user";

const Result = (props) => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("review");
  }, []);


  useEffect(() => {
    const progressDone = localStorage.getItem("progressDone");
    const detailDone = localStorage.getItem("detailDone");

    if (!progressDone) {
      navigate("/progress");
    } else if (!detailDone) {
      navigate("/profiledetail");
    }
  }, [navigate]);

  return (
    <Container>
      <ResultBody />
    </Container>
  );
};

const actionCreators = { updateUserData, getSurveyList };

export default connect(
  ({ user }) => ({ user }),
  actionCreators
)(Result);
